import { render, staticRenderFns } from "./sendOrderDialog.vue?vue&type=template&id=9c9f4b86&"
import script from "./sendOrderDialog.vue?vue&type=script&lang=js&"
export * from "./sendOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports